exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "main {\n    top: 0;\n    padding: 0;\n}\n\n.main-wrapper {\n    /* border: 1px red solid; */\n    margin-top: 30px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main